export default {
    meta: {
        title: '鱼你在一起-关联机会点',
        url: '/fishtogether/tasklist',
        urlName: '鱼你拓店任务'
    }
};
